import React, { type ReactElement } from 'react';
import { useFormContext } from 'react-hook-form';
import ErrorMessage from 'atom-components/error-message-from-hook-form';
import TextInput from 'atom-components/form-fields-for-hook-form/text-input';
import FormLabelAndInputContainer from 'atom-components/form-label-and-input-container';
import Label from 'atom-components/label';

export default function Name(): ReactElement {
  const { control, formState } = useFormContext();
  const fieldName = 'name';
  const fieldLabel = 'Name';

  return (
    <FormLabelAndInputContainer>
      <Label required htmlFor={fieldName}>
        {fieldLabel}
      </Label>
      <TextInput id={fieldName} control={control} name={fieldName} ariaLabel={fieldLabel} />
      {formState.errors.name && <ErrorMessage errors={formState.errors} name={fieldName} />}
    </FormLabelAndInputContainer>
  );
}
